import * as React from 'react';

export default class A2ZSort extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
         <path fill="#43ADF1" strokeWidth="0"  fillRule="evenodd" d="M13.854 7.207l-.398-1.033h-2.565l-.398 1.033h-1.04l2.128-5.38h1.185l2.127 5.38h-1.039zm-1.68-4.582l-1.015 2.718h2.03l-1.015-2.718z" clipRule="evenodd"/>
         <path fill="#000" strokeWidth="0" fillRule="evenodd" d="M10.144 15.273v-.767l2.768-3.783h-2.768v-.83h4.002v.766l-2.768 3.783h2.825v.83h-4.06z" clipRule="evenodd"/>
         <path stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" d="M5.055 1.994v11.834M1.762 11.559l3.29 2.901 3.289-2.901"/>
      </svg>
    )
  }
}
